import React from "react";
import { Switch, Route } from "react-router-dom";

import SetupPage from "./Setup/SetupPage";
import VehiclesRouter from "./Vehicles";
import InspectionsRouter from "./Inspections";
import WorkOrdersRouter from "./WorkOrders";
import WOProcessingRouter from "./WorkOrdersProcessing";
import SystemCodeRouter from "./SystemCodes";
import VehicleOutOfServicesRouter from "./VehicleOutOfServices";
import VendorsRouter from "./Vendors";

const FleetManagementRouter = () => (
  <Switch>
    <Route path="/fleet/vehicle-status-processing">
      <VehicleOutOfServicesRouter />
    </Route>
    <Route path="/fleet/system-codes">
      <SystemCodeRouter />
    </Route>
    <Route path="/fleet/setup">
      <SetupPage />
    </Route>
    <Route path="/fleet/vehicles">
      <VehiclesRouter />
    </Route>
    <Route path="/fleet/inspection-masters">
      <InspectionsRouter />
    </Route>
    <Route path="/fleet/work-orders">
      <WorkOrdersRouter />
    </Route>
    <Route path="/fleet/work-orders-processing">
      <WOProcessingRouter />
    </Route>
    <Route path="/fleet/vendors">
      <VendorsRouter />
    </Route>
  </Switch>
);

export default FleetManagementRouter;
